function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9sh59ri30a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4443",
    style: {
      fill: "#17ae7b"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17847",
    style: {
      clipPath: "url(#9sh59ri30a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25422",
    d: "M7.247 19.355h.915l9.209-9.209-.915-.915-9.209 9.209zm12.764-10.1-2.66-2.664.869-.869a1.169 1.169 0 0 1 .887-.347 1.235 1.235 0 0 1 .884.364l.894.894a1.255 1.255 0 0 1 0 1.745zM6.63 20.6a.619.619 0 0 1-.63-.63v-1.78a.612.612 0 0 1 .042-.23.633.633 0 0 1 .146-.208l10.29-10.29 2.661 2.661L8.848 20.415a.586.586 0 0 1-.437.187zM16.914 9.688l-.457-.457.915.915z",
    transform: "translate(-3.143 -2.517)",
    style: {
      fill: "#032541"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcn);
export default __webpack_public_path__ + "static/media/edit-icn.ba38dd26565ac8febe24cb8cf951e0fb.svg";
export { ForwardRef as ReactComponent };